import superStorageAbstract from "./superStorageAbstract";


class superStorageSession extends superStorageAbstract
{
    /**
     * Obtiene un elemento JS del almacenamiento
     * @param {string} itemName Clave de guardado
     * @return {Object|null} Objeto encontrado o null en caso contrario
     */
    getItem(itemName){
        const plain = sessionStorage.getItem(itemName);
        if(!plain) return null;
        return this.jsonStringify2Object(plain);
    }

    /**
     * Guarda un objeto en el almacenamiento
     * @param {string} itemName Clave de guardado
     * @param {object} item Elemento a guardar
     */
    setItem(itemName, item)
    {
        const itemString = JSON.stringify(item);
        sessionStorage.setItem(itemName, itemString);
    }

    /**
     * Elimina un objeto del almacenamiento
     * @param {string} itemName Clave de guardado
     */
    removeItem(itemName)
    {
        sessionStorage.removeItem(itemName);
    }
}

export default superStorageSession;
